import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { productPurchaseChurnTrend, productPurchaseChurnTrendCurrency } from "@/api/dataAll/dataAll";
import { mapState } from 'vuex';
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "postPurchaseChurnTrend",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: this.$t('newRegisterUser'),
        id: "register"
      }, {
        label: this.$t('activeUsers'),
        id: "login"
      }],
      searchData: {
        user_type: "register",
        product_ids: '',
        churn_days: ''
      },
      tableList: [],
      serverList: [],
      // 新增：显示模式
      displayMode: 'both',
      // both, count, ratio
      lastRawList: null
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  watch: {
    displayMode: function displayMode() {
      if (this.lastRawList) {
        this.searchClickNew(this.lastRawList);
      }
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchCurrency, reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchCurrency = _this2.$store.state.d2admin.serchSelect.searchCurrency;
                reqFn = searchCurrency.length ? productPurchaseChurnTrendCurrency : productPurchaseChurnTrend;

                if (_this2.searchData.product_ids) {
                  _context.next = 5;
                  break;
                }

                _this2.$message.error(_this2.$t('pleaseFillProductId'));

                return _context.abrupt("return");

              case 5:
                _this2.reqLoading = true;
                _this2.searchData.server_id = _this2.paramsData.server_id;

                _this2.searchClickLoop(reqFn, 1);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClickNew: function searchClickNew(lists) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var rawList, items, columns, firstChurn, dayKeys;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.lastRawList = JSON.parse(JSON.stringify(lists));
                rawList = JSON.parse(JSON.stringify(lists));

                if (rawList.length) {
                  _context2.next = 6;
                  break;
                }

                _this3.tableList = [];
                _this3.tableData = [];
                return _context2.abrupt("return");

              case 6:
                // 1. 提取所有包含的数据行项（兼容后端以 "0", "1" 等索引为 key 的对象）
                items = rawList.map(function (item) {
                  return item[0] || item['0'];
                }).filter(Boolean); // 2. 动态生成表头定义 (tableList)

                columns = [{
                  label: _this3.$t('date'),
                  prop: 'date'
                }, {
                  label: _this3.$t('currentDayPurchaseCount'),
                  prop: 'count'
                }]; // 获取天数列表 (如 day1, day2...)

                firstChurn = items[0] && items[0].churn ? items[0].churn : {};
                dayKeys = Object.keys(firstChurn);
                dayKeys.forEach(function (dayKey) {
                  var dayNum = dayKey.replace('day', '');
                  var labelText = dayKey;

                  if (_this3.displayMode === 'both') {
                    labelText += ' ' + _this3.$t('countSlashRatio');
                  } else if (_this3.displayMode === 'count') {
                    labelText += ' ' + _this3.$t('personCount');
                  } else if (_this3.displayMode === 'ratio') {
                    labelText += ' ' + _this3.$t('ratioLabel');
                  }

                  columns.push({
                    label: labelText,
                    prop: dayKey
                  });
                });
                _this3.tableList = columns; // 3. 组装表格行数据 (tableData)

                _this3.tableData = items.map(function (item) {
                  var row = {
                    date: item.date,
                    count: item.count
                  };

                  if (item.churn) {
                    Object.keys(item.churn).forEach(function (dayKey) {
                      var churnItem = item.churn[dayKey] || {
                        count: 0,
                        rate: 0
                      };
                      var countVal = churnItem.count;
                      var rateVal = "".concat(churnItem.rate, "%"); // 根据 displayMode 拼接显示格式

                      if (_this3.displayMode === 'both') {
                        row[dayKey] = "".concat(countVal, " / ").concat(rateVal);
                      } else if (_this3.displayMode === 'count') {
                        row[dayKey] = countVal;
                      } else if (_this3.displayMode === 'ratio') {
                        row[dayKey] = rateVal;
                      }
                    });
                  }

                  return row;
                }); // console.log("qres====",qres)

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {}; // 使用当前的tableList进行导出

      this.tableList.forEach(function (item, index) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};